<template>
  <div>
    <!-- begin breadcrumb -->
    <ol class="breadcrumb pull-right">
      <li class="breadcrumb-item">
        <a href="javascript:;">Home</a>
      </li>
      <li class="breadcrumb-item active">Dashboard</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">
      工作台
      <small>销售数据统计...</small>
    </h1>
    <!-- end page-header -->

    <div class="row">
      <div class="col-md-12">
        <Card :bordered="false">
          <button type="button" :class="classstatus('today')" @click="fn_show('today')">今天</button>
          <button type="button" :class="classstatus('yestoday')" @click="fn_show('yestoday')">昨天</button>
          <button type="button" :class="classstatus('last7day')" @click="fn_show('last7day')">最近7天</button>
          <button
            type="button"
            :class="classstatus('last30day')"
            style="margin-right:100px"
            @click="fn_show('last30day')"
          >最近30天</button>

          <DatePicker type="date" v-model="date_begindate" placeholder="开始日期" style="width: 150px"></DatePicker>至
          <DatePicker type="date" v-model="date_enddate" placeholder="结束日期" style="width: 150px"></DatePicker>

          <button class="btn btn-theme" type="button" @click="fn_query">
            <i class="fa fa-search"></i>查询
          </button>
        </Card>
      </div>
    </div>
    <!-- begin row -->
    <div class="row m-t-10">
      <!-- begin col-3 -->
      <div class="col-lg-2 col-md-6">
        <div class="widget widget-stats bg-blue">
          <div class="stats-icon">
            <i class="fa fa-yen-sign"></i>
          </div>
          <div class="stats-info">
            <h4>微信付款金额</h4>
            <p>{{ staticdata.wxorderamount }}</p>
          </div>
        </div>
      </div>
      <div class="col-lg-2 col-md-6">
        <div class="widget widget-stats bg-blue">
          <div class="stats-icon">
            <i class="fa fa-yen-sign"></i>
          </div>
          <div class="stats-info">
            <h4>支付宝付款金额</h4>
            <p>{{ staticdata.zfborderamount }}</p>
          </div>
        </div>
      </div>
      <div class="col-lg-2 col-md-6">
        <div class="widget widget-stats bg-blue">
          <div class="stats-icon">
            <i class="fa fa-yen-sign"></i>
          </div>
          <div class="stats-info">
            <h4>余额付款金额</h4>
            <p>{{ staticdata.yeorderamount }}</p>
          </div>
        </div>
      </div>
      <!-- end col-3 -->
      <!-- begin col-3 -->
      <div class="col-lg-2 col-md-6">
        <div class="widget widget-stats bg-orange">
          <div class="stats-icon">
            <i class="fa fa-link"></i>
          </div>
          <div class="stats-info">
            <h4>付款订单数</h4>
            <p>{{ staticdata.ordercount }}</p>
          </div>
        </div>
      </div>
      <!-- end col-3 -->
      <!-- begin col-3 -->
      <div class="col-lg-2 col-md-6">
        <div class="widget widget-stats bg-grey-darker">
          <div class="stats-icon">
            <i class="fa fa-users"></i>
          </div>
          <div class="stats-info">
            <h4>付款买家数</h4>
            <p>{{ staticdata.usercount }}</p>
          </div>
        </div>
      </div>
      <!-- end col-3 -->
      <!-- begin col-3 -->
      <div class="col-lg-2 col-md-6">
        <div class="widget widget-stats bg-black-lighter">
          <div class="stats-icon">
            <i class="fa fa-gift"></i>
          </div>
          <div class="stats-info">
            <h4>付款商品件数</h4>
            <p>{{ staticdata.goodscount }}</p>
          </div>
        </div>
      </div>
      <!-- end col-3 -->
    </div>
    <!-- end row -->
    <!-- begin row -->
    <div class="row">
      <!-- begin col-8 -->
      <div class="col-lg-8">
        <!-- begin panel -->
        <panel title="最近15天销售数据" :noButton="true">
          <line-chart :data="lineChart" class="height-sm"></line-chart>
        </panel>
        <panel title="最近15天新增会员数" :noButton="true">
          <line-chart :data="lineChartUser" class="height-sm"></line-chart>
        </panel>
        <!-- end panel -->
      </div>
      <!-- end col-8 -->
      <div class="col-lg-4">
        <panel title="销售商品前5名" :noButton="true">
          <doughnut-chart :data="doughnutChart" class="height-sm"></doughnut-chart>
        </panel>
      </div>
    </div>
    <!-- end row -->
  </div>
</template>

<script>
import LineChart from "../components/vue-chartjs/LineChart";
import DoughnutChart from "../components/vue-chartjs/DoughnutChart";
import { getHomeData } from "@/api/home";
import moment from "moment";
export default {
  components: {
    LineChart,
    DoughnutChart
  },
  data() {
    return {
      lineChart: {},
      lineChartUser: {},
      doughnutChart: {},
      begindate: "",
      enddate: "",
      date_begindate: "",
      date_enddate: "",
      dateflag: "today",
      staticdata: {},
      goodsLabel: [],
      goodsCount: []
    };
  },
  mounted() {
    this.fn_show("today");
  },
  computed: {},
  methods: {
    classstatus(day) {
      if (day == this.dateflag) return "btn btn-primary m-r-10";
      else return "btn btn-theme m-r-10";
    },
    fn_show(showday) {
      this.dateflag = showday;
      switch (showday) {
        case "today":
          this.begindate = moment().format("YYYY-MM-DD");
          this.enddate = moment().format("YYYY-MM-DD");

          break;
        case "yestoday":
          this.begindate = moment()
            .subtract(1, "day")
            .format("YYYY-MM-DD");
          this.enddate = this.begindate;
          break;
        case "last7day":
          this.begindate = moment()
            .subtract(7, "day")
            .format("YYYY-MM-DD");
          this.enddate = moment().format("YYYY-MM-DD");
          break;
        case "last30day":
          this.begindate = moment()
            .subtract(30, "day")
            .format("YYYY-MM-DD");
          this.enddate = moment().format("YYYY-MM-DD");
          break;
      }
      this.fn_loaddata();
    },
    fn_query() {
      this.begindate = moment(this.date_begindate).format("YYYY-MM-DD");
      this.enddate = moment(this.date_enddate).format("YYYY-MM-DD");
      if (
        this.begindate !== "Invalid date" &&
        this.enddate !== "Invalid date"
      ) {
        this.fn_loaddata();
      }
    },
    fn_loaddata() {
      console.log(this.begindate, this.enddate);
      getHomeData({
        begindate: this.begindate,
        enddate: this.enddate
      })
        .then(res => {
          this.staticdata = res.data.static[0];
          let goods = res.data.goodssort;
          this.goodsLabel = [];
          this.goodsCount = [];
          for (let index = 0; index < goods.length; index++) {
            const element = goods[index];
            this.goodsLabel.push(element.goods_name);
            this.goodsCount.push(element.count);
          }

          this.doughnutChart = {
            data: {
              labels: this.goodsLabel,
              datasets: [
                {
                  backgroundColor: [
                    "#5b6392",
                    "#727cb6",
                    "#8e93d5",
                    "#348fe2",
                    "#2a72b5"
                  ],
                  data: this.goodsCount
                }
              ]
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              cutoutPercentage: 70
            }
          };

          //趋势图
          let treaddata = res.data.trenddata;

          let trendlabel = [];
          let ordercount = [];
          let wxpay = [];
          let zfbpay = [];
          let yepay = [];
          let maxvalue = 0;
          for (let index = 0; index < treaddata.length; index++) {
            const element = treaddata[index];
            ordercount.push(element.ordercount);
            wxpay.push(element.wxorderamount);
            zfbpay.push(element.zfborderamount);
            yepay.push(element.yeorderamount);
            trendlabel.push(element.orderdate);
            if (parseFloat(element.yeorderamount) > maxvalue)
              maxvalue = parseFloat(element.yeorderamount);

            if (parseFloat(element.wxpay) > maxvalue)
              maxvalue = parseFloat(element.wxpay);

            if (parseFloat(element.zfbpay) > maxvalue)
              maxvalue = parseFloat(element.zfbpay);
          }

          this.lineChart = {
            data: {
              labels: trendlabel,
              datasets: [
                {
                  label: "订单数",
                  backgroundColor: "rgba(52, 143, 226, 0.2)",
                  borderColor: "#348fe2",
                  pointBackgroundColor: "#348fe2",
                  pointRadius: 2,
                  borderWidth: 2,
                  data: ordercount
                },
                {
                  label: "微信支付",
                  backgroundColor: "rgba(45, 53, 60, 0.2)",
                  borderColor: "#2d353c",
                  pointBackgroundColor: "#2d353c",
                  pointRadius: 2,
                  borderWidth: 2,
                  data: wxpay
                },
                {
                  label: "支付宝支付",
                  backgroundColor: "rgba(45, 53, 60, 0.2)",
                  borderColor: "#2d653c",
                  pointBackgroundColor: "#2d553c",
                  pointRadius: 2,
                  borderWidth: 2,
                  data: zfbpay
                },
                {
                  label: "余额支付",
                  backgroundColor: "rgba(45, 53, 60, 0.2)",
                  borderColor: "#2d33d3",
                  pointBackgroundColor: "#2d33d3",
                  pointRadius: 2,
                  borderWidth: 2,
                  data: yepay
                }
              ]
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              hover: {
                mode: "nearest",
                intersect: true
              },
              tooltips: {
                mode: "index",
                intersect: false
              },
              scales: {
                yAxes: [
                  {
                    ticks: {
                      beginAtZero: true,
                      max: maxvalue
                    }
                  }
                ]
              }
            }
          };

          //   console.log(this.lineChart);
          let treaddataUser = res.data.treaddataUser;
          let trendlabelUser = [];
          let userCount = [];

          maxvalue = 0;
          for (let index = 0; index < treaddataUser.length; index++) {
            const element = treaddataUser[index];
            userCount.push(element.usercount);

            trendlabelUser.push(element.userdate);

            if (parseFloat(element.usercount) > maxvalue)
              maxvalue = parseFloat(element.usercount);
          }
          this.lineChartUser = {
            data: {
              labels: trendlabelUser,
              datasets: [
                {
                  label: "新会员数",
                  backgroundColor: "rgba(52, 143, 226, 0.2)",
                  borderColor: "#348fe2",
                  pointBackgroundColor: "#348fe2",
                  pointRadius: 2,
                  borderWidth: 2,
                  data: userCount
                }
              ]
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              hover: {
                mode: "nearest",
                intersect: true
              },
              tooltips: {
                mode: "index",
                intersect: false
              },
              scales: {
                yAxes: [
                  {
                    ticks: {
                      beginAtZero: true,
                      max: maxvalue
                    }
                  }
                ]
              }
            }
          };
        })
        .catch(error => {
          this.$Message.error("error" + error);
        });
    }
  }
};
</script>
